import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, timeout: 20000 });

const TK = "sp_tokens";
export const getTokens = () => JSON.parse(localStorage.getItem(TK) || "null");
export const setTokens = (t) => (t ? localStorage.setItem(TK, JSON.stringify(t)) : localStorage.removeItem(TK));

let staffId = null;
export const setApiStaff = (id) => { staffId = id || null; };

api.interceptors.request.use((cfg) => {
  const t = getTokens();
  if (t) cfg.headers.Authorization = `Bearer ${t.access_token}`;
  if (staffId) cfg.headers["X-Staff-Id"] = staffId;
  cfg.headers["X-Device-Id"] = localStorage.getItem("sp_device") || "";
  return cfg;
});

api.interceptors.response.use((r) => r, async (err) => {
  const cfg = err.config || {};
  const t = getTokens();
  if (err.response?.status === 401 && t?.refresh_token && !cfg._retry && !String(cfg.url).includes("/auth/")) {
    cfg._retry = true;
    try {
      const { data } = await axios.post(`${API}/auth/refresh`, { refresh_token: t.refresh_token });
      setTokens(data);
      cfg.headers.Authorization = `Bearer ${data.access_token}`;
      return api(cfg);
    } catch (e) {
      return Promise.reject(err);
    }
  }
  return Promise.reject(err);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}
